import React from 'react';
import './ServiceDropdown.css';

const ServiceDropdown = ({ show }) => {
  const residentialServices = [
    { name: "Electrical system diagnostic", description: "We analyze faulty circuits or equipment to find safe, cost-effective repair solutions." },
    { name: "Whole home electrical renovations", description: "During renovations we secure permits, complete inspections, and provide transparent, no-hidden-fee quotes." },
    { name: "New electrical panel & sub-panel installations", description: "Install new panels or sub-panels with modern breakers, meeting Canadian Electrical Code standards." },
    { name: "EV Charging", description: "Install, maintain, and repair EV charging stations, including Level 1, Level 2, load misers, and disconnects." },
    { name: "New underground & overhead service installations", description: "Supply and install new underground or overhead services, including permits, inspections, and utility coordination." },
    { name: "Repair existing services", description: "Upgrade or relocate existing 60A or 100A services, ensuring code compliance with inspections." },
    { name: "Hot tubs, pools & spas", description: "Certified electricians safely install hot tubs, pools, saunas, or spas for reliable enjoyment." },
    { name: "Aluminum circuit & panel wire remediation", description: "Replace aluminum connections with copper pigtails and anti-oxide gel to reduce overheating risks." },
    { name: "Electrical inspections", description: "Comprehensive home electrical inspection identifies deficiencies, ensuring safety and code compliance." },
    { name: "Recessed LED lighting", description: "Install energy-efficient recessed LEDs to modernize interiors and reduce energy costs." },
    { name: "Undercounter & accent lighting", description: "Add cabinet or accent lighting to enhance workspace function and home ambiance." },
    { name: "Chandeliers & pendants", description: "Professionally install chandeliers and pendant lights to elevate home décor." },
    { name: "USB & data cabling", description: "Provide and install quality network cabling tailored to your needs and budget." },
    { name: "Ceiling fans", description: "Install ceiling fans to improve comfort, airflow, and energy efficiency." },
    { name: "Security & architectural lighting", description: "Install lighting to improve safety, deter entry, reduce accidents, and enhance curb appeal." },
    { name: "GFCI protection", description: "GFCI devices cut power during ground faults, preventing electrical shock near water sources." },
    { name: "AFCI protection", description: "AFCI breakers stop dangerous arcs, protecting your home from electrical fires." },
  ];

  const commercialServices = [
    { name: "Electrical system diagnostic", description: "Analyze faulty circuits or equipment to find safe, cost-effective repair solutions." },
    { name: "Panel upgrades & relocations", description: "Upgrade or relocate panels/sub-panels to meet your business’s growing power demands." },
    { name: "Metering & service upgrades", description: "Replace or relocate meter bases, handle permits, inspections, and coordinate with utility providers." },
    { name: "Warehouse & office lighting", description: "Maintain or upgrade high bay lighting and LED solutions in warehouses or office spaces." },
    { name: "LED lighting upgrades", description: "Retrofit fluorescent fixtures or install modern LED panels to cut energy and maintenance costs." },
    { name: "Electrical inspections", description: "Conduct full electrical assessments, identify code violations, recommend urgent fixes or improvements." },
    { name: "USB & data cabling", description: "Install and advise on network cabling types suited to your budget and performance needs." },
    { name: "Emergency & security lighting", description: "Install battery-backup lighting for walkways, stairs, parking to keep premises safe during outages." },
    { name: "Architectural & landscape lighting", description: "Illuminate pathways, facades, signage, and outdoor spaces to enhance your brand and aesthetics." },
    { name: "Transformer Installation", description: "Install transformers to control voltage for battery charging or varied equipment voltage needs." },
    { name: "Generator Installation", description: "Install permanent or temporary generators with automatic transfer switching for reliable backup power." },
    { name: "EV Charging", description: "Install Level 1 and Level 2 EV chargers to attract customers or provide convenience for employees." },
  ];

  const emergencyServices = [
    { name: "Electrical systems diagnostic", description: "Identify circuit failures, faulty equipment, and repair needs during urgent situations." },
    { name: "Emergency lighting & exit signs", description: "Keep hallways, exits, and stairwells safely lit during power outages." },
    { name: "Smoke, fire & carbon monoxide detectors", description: "Install, replace, and maintain detectors for early warning and compliance." },
    { name: "Generator installations", description: "Provide temporary or permanent generators with transfer switches for reliable backup." },
    { name: "Loss of power and lighting", description: "Restore service quickly and ensure critical systems are safely re-energized." },
    { name: "Surge protection", description: "Install surge devices to protect electronics and appliances from power spikes." },
    { name: "Circuit breaker repair / replacement", description: "Diagnose and replace tripping or faulty breakers causing safety risks." },
    { name: "Sparking outlet repair", description: "Fix overheated or sparking outlets and switches before fires occur." },
    { name: "Exposed wiring repair", description: "Address damaged or exposed wiring to eliminate immediate hazards." },
    { name: "Electrical fire mitigation", description: "Inspect and secure systems after small fires to prevent recurrence." },
    { name: "Shock hazard response", description: "Investigate shocks from outlets or equipment and correct underlying faults." },
    { name: "Panel safety evaluation", description: "Test panels for overheating, loose connections, or outdated parts." },
  ];

  const residentialServicesHalf = Math.ceil(residentialServices.length / 2);
  const residentialServicesCol1 = residentialServices.slice(0, residentialServicesHalf);
  const residentialServicesCol2 = residentialServices.slice(residentialServicesHalf);

  return (
    <div className={`service-dropdown ${show ? 'show' : ''}`}>
      <div className="dropdown-column">
        <h3>Emergency</h3>
        <ul>
          {emergencyServices.map((service, index) => (
            <li key={index}>
              {service.name}
              <p className="service-description">{service.description}</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="dropdown-column">
        <h3>Commercial</h3>
        <ul>
          {commercialServices.map((service, index) => (
            <li key={index}>
              {service.name}
              <p className="service-description">{service.description}</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="dropdown-column residential-column"> {/* Added class for specific styling */}
        <h3>Residential</h3>
        <div className="residential-columns-wrapper"> {/* Wrapper for two columns */}
          <ul>
            {residentialServicesCol1.map((service, index) => (
              <li key={index}>
                {service.name}
                <p className="service-description">{service.description}</p>
              </li>
            ))}
          </ul>
          <ul>
            {residentialServicesCol2.map((service, index) => (
              <li key={index}>
                {service.name}
                <p className="service-description">{service.description}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ServiceDropdown;
